/**
 * Shared agent display labels — single source of truth for event/message labels.
 */

/** Labels for agent display in events/messages */
export const AGENT_LABELS: Record<string, string> = {
  casey: 'Casey',
  'hpi-pe-agent': 'The Historian',
  'clinical-reasoning': 'The Resident',
  system: 'System',
}
